import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top on every route change.
 *
 * React Router keeps the previous page's scroll offset across client-side
 * navigations, so on mobile a user who had scrolled down the tests hub
 * arrived at the next test page already scrolled to the bottom. Mounted once
 * inside the router (see router/Router.js); renders nothing.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  // The browser's own history scroll restoration can re-apply a saved offset
  // AFTER React mounts the new page (especially on mobile with lazy-loaded
  // routes), overriding our reset — take manual control of it.
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    // instant (not smooth) so the new page never flashes mid-scroll,
    // plus direct element resets for older mobile browsers
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
